import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  logMessageTimeout: 8000,
  messages: [],
};

const loggerSlice = createSlice({
  name: 'logger',
  initialState,
  reducers: {
    logMessage: (state, action) => ({
      ...state,
      messages: state.messages.concat(action.payload),
    }),
    hideMessage: (state, action) => ({
      ...state,
      messages: state.messages.filter(msg => msg.id !== action.payload),
    }),
  },
});

export const { logMessage, hideMessage } = loggerSlice.actions;

export default loggerSlice.reducer;

export const getLogMessagesTimeout = state => state.logMessageTimeout;
export const getActiveMessages = state => state.messages.filter(msg => msg.active);
